module.exports = __webpack_public_path__ + "static/media/marker.b012eb82.svg";